import i18nFactory, { i18nRaw as i18nRawFactory } from '@yandex-int/i18n';
import { Button } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { formatNumber } from '../../../service/FormatHelpers/FormatHelpers';
import { pluralizeWord } from '../../../service/Pluralize/Pluralize';
import {
    RecommendationCharacter,
    RecommendationType
} from '../../../typings/recommendations';
import { Image2 } from '../../Image2/Image2';
import { Shape2Icon } from '../../Shape2/Shape2';
import {
    RecommendationCard,
    RecommendationCardView
} from '../RecommendationCard';

import './AddAdditionsItemCalloutsRecommendationCard.css';
import * as keyset from './AddAdditionsItemCalloutsRecommendationCard.i18n';
import * as additionsItemCalloutsExample1x from './AdditionsItemCalloutsExample@1x.jpg';
import * as additionsItemCalloutsExample2x from './AdditionsItemCalloutsExample@2x.jpg';
import * as additionsItemCalloutsExample3x from './AdditionsItemCalloutsExample@3x.jpg';

const i18n = i18nFactory(keyset);
const i18nRaw = i18nRawFactory(keyset);

interface RecommendationsPopupViewProps {
    character: RecommendationCharacter;
    icon: Shape2Icon;
    view: RecommendationCardView.recommendationsPopup;
    onShow?: (view: RecommendationCardView, type: RecommendationType) => void;
}

interface NormalViewProps {
    character: RecommendationCharacter;
    icon: Shape2Icon;
    view: RecommendationCardView.normal;
    bannersNumber: number;
    bannersPageUrl: string;
    onShow?: (view: RecommendationCardView, type: RecommendationType) => void;
}

export type AddAdditionsItemCalloutsRecommendationCardProps =
    | RecommendationsPopupViewProps
    | NormalViewProps;

export class AddAdditionsItemCalloutsRecommendationCard extends React.Component<
    AddAdditionsItemCalloutsRecommendationCardProps
> {
    render() {
        const { view, character, icon, onShow } = this.props;

        return (
            <RecommendationCard
                type={RecommendationType.addAdditionsItemCallouts}
                icon={icon}
                character={character}
                title={this.getTitle()}
                titleHint={this.getTitleHint()}
                view={view}
                isInProgress={false}
                buttons={this.getButtons()}
                onShow={onShow}
            >
                {this.getBody()}
            </RecommendationCard>
        );
    }

    private getTitleHint = (): string => {
        if (this.props.view === RecommendationCardView.recommendationsPopup) {
            return i18n('popup-view-title-hint');
        }

        return i18n('normal-view-title-hint');
    };

    private getTitle = (): string => {
        if (this.props.view === RecommendationCardView.recommendationsPopup) {
            return i18n('popup-view-title');
        }

        return i18n('normal-view-title');
    };

    private getBody = () => {
        return (
            <>
                <div
                    className={Bem.cls(
                        'add-additions-item-callouts-recommendation-card',
                        'example-wrapper'
                    )}
                >
                    <Image2
                        src={{
                            src: additionsItemCalloutsExample1x,
                            src2x: additionsItemCalloutsExample2x,
                            src3x: additionsItemCalloutsExample3x
                        }}
                        cls={Bem.cls(
                            'add-additions-item-callouts-recommendation-card',
                            'example'
                        )}
                    />
                </div>

                <p
                    className={Bem.cls(
                        'add-additions-item-callouts-recommendation-card',
                        'body-text'
                    )}
                >
                    {i18nRaw('title-extension-desc1', {
                        value: (
                            <b
                                className={Bem.cls(
                                    'add-additions-item-callouts-recommendation-card',
                                    'sign-text'
                                )}
                                key={1}
                            >
                                {i18n('percent-value', { value: 3 })}
                            </b>
                        )
                    })}
                </p>

                <p
                    className={Bem.cls(
                        'add-additions-item-callouts-recommendation-card',
                        'body-text'
                    )}
                >
                    {i18n('title-extension-desc2')}
                </p>
            </>
        );
    };

    private getButtons = () => {
        if (this.props.view === RecommendationCardView.recommendationsPopup) {
            return undefined;
        }

        const { bannersNumber, bannersPageUrl } = this.props;
        const formattedItemsLength = formatNumber(bannersNumber);

        const buttonText = pluralizeWord(
            [
                i18n('show-one-banner-button', {
                    count: formattedItemsLength
                }),
                i18n('show-some-banner-button', {
                    count: formattedItemsLength
                }),
                i18n('show-many-banner-button', {
                    count: formattedItemsLength
                })
            ],
            bannersNumber
        );

        return [
            <Button
                key={1}
                theme={'action'}
                size={'n'}
                text={buttonText}
                type={'link'}
                url={bannersPageUrl}
            />
        ];
    };
}
